import Section from '../../components/Section';
import Technology from './components/Technology';

const Experience = () => {
    const technologies = ['Vue', 'Javascript', 'Java', 'Spring', 'Hibernate', 'Vuetify', 'HTML5', 'CSS3', 'SCSS', 'Docker', 'MySQL', 'Mongo']
    return (
        <main id="experience" className="flex flex-col justify-center items-center bg-gray-50">
            <Section title="Professional Experience" subtitle="What I have done!">
                <div className="md:w-3/5 w-4/5">
                    <h2 className="font-bold mb-0">
                        <span className="text-lg">Software Engineer I</span>
                        <span className="text-red-500"> @ Applied Medical</span>
                    </h2>
                    <span className="text-sm font-bold text-gray-500">March 2022 - June 2023</span>
                    <span className='text-gray-900'> • </span>
                    <span className="text-sm font-medium text-gray-400">Rancho Santa Margarita, CA</span>
                    {/* TODO update bullet point design */}
                    <ul class="list-disc flex flex-col gap-2 mt-4 ml-4 bullet-point-list">
                        <li>Developed and maintained production frontend features, pages, and interactive data visualizations for a web-based medical simulation platform used by residents and surgeons</li>
                        <li>Designed and implemented backend services, REST APIs, relational database schemas, and migration scripts supporting core application functionality</li>
                        <li>Designed automated backup and disaster recovery workflows using Dockerized services, scheduled jobs, and Azure cloud storage, identifying and resolving failures in the existing implementation</li>
                        <li>Developed JUnit and Jest test suites and participated in stress testing efforts to improve release readiness and application reliability</li>
                        <li>Collaborated with a 7-person Agile engineering team on feature design, technical planning, bug fixes, and production releases</li>
                    </ul>
                    {/* TODO update tech? is this only applied tech ?  */}
                    <div className="mt-8">
                        <h4 class="font-semibold text-gray-500 mb-4">Technologies</h4>
                        <ul className="flex flex-wrap gap-4">
                            {technologies.map(name => (
                                <li><Technology name={name} /></li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Section>
        </main>
    )
}

export default Experience;